import { Toast } from 'types/layout';

export const genericErrorToast: Toast = {
	type: 'error',
	message:
		'An error has occurred. The error has been logged and we&rsquo;ll look into it immediately. If you need assistance, contact us at&nbsp;<a href="mailto:support@fundrise.com">support@fundrise.com</a>.'
};
